module.exports = __webpack_public_path__ + "static/media/holy-oysters-take-me-for-a-ride-official.391e5332.mp3";